import { DefaultPageConfig } from 'config/routeConfig';
import NextErrorComponent from 'next/error';


const MyError = ({ statusCode, hasGetInitialPropsRun, err }) => {
  return <section className="flex jcc align-i-center h100 mt-2xl">
    <div className="bg-white p-xxl max-w-400 mt-2xl">
      {statusCode === 404 ?
        <h4 className="align-center">متاسفانه صفحه مورد نظر شما یافت نشد</h4>
        :
        <h4 className="align-center">متاسفانه در ارائه خدمات سیستم با مشکل مواجه شده است، لطفا دوباره تلاش نمایید</h4>
      }
    </div>
  </section>
};



MyError.getInitialProps = async (context) => {
  const errorInitialProps = await NextErrorComponent.getInitialProps(context);


  // Workaround for https://github.com/vercel/next.js/issues/8592, mark when
  // getInitialProps has run
  errorInitialProps.hasGetInitialPropsRun = true;

  return errorInitialProps;
};

MyError.config = DefaultPageConfig;

export default MyError